<template>
    <div class="container">
        <h1>Comment staker ses ADAs avec Adalite</h1>

        <p>Page en cours de rédaction. Ça arrive très vite !</p>
    </div>
</template>

<script>
import createHeader from "../../js/meta.js";

export default {
    layout: 'DocLayout',
    head: createHeader({
        title: "Comment staker ses ADAs (contre des intérêts) avec Adalite - Stakepool.fr",
        description: "Apprenez à déleguer vos ADAs pour participer au fonctionnement de la blockchain Cardano, contre des interêts. Tutoriel avec le portefeuille Adalite."
    })
};
</script>